import {Link} from 'react-router-dom';

const ConnectSection = () => {
    return (
        <section id="connect">
            <div className="content">
                <div className="title">
                    <h1>Le nouvel <span>allié</span> pour apprendre les langues avec une approche orientée <span>business</span> !</h1>
                </div>
                <div className="connexion">
                    {/* <?php if (!$session->get('isMobile')) { ?> */}
                    <Link to="/login" className="btn btn1">connexion</Link>
                    {/* <?php } ?> */}
                    {/*<Link to="/register" className="btn btn2">créer un compte</Link>*/}
                </div>
            </div>
        </section>
    );
};


export default ConnectSection;